import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import { CSS_MQ } from "../../styles/breakpoints";
import { ContentfulImage } from "../../components/_shared-components/image-related/ContentfulImage";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { ReactComponent as MagnifySvgIcon } from "../../assets/icons/Icon/DKT/Magnify black.svg";
import React from "react";
import { PDPImagesGridImageT } from "./PDP_Gallery/types";

export const desktopStickyStyles = css`
  max-height: max(100%, var(--mh));
  position: sticky;
  top: calc(var(--header-pinned-height) + 12px);
`;

export const PDPAboveTheFoldMainImageDesktop: ReactTFC<{
  openModal: (url: string) => void;
  primaryImage: PDPImagesGridImageT;
  children: React.ReactNode;
}> = props => {
  return (
    <div
      className={"js-pdp-above-the-fold-main-image"}
      css={[
        css`
          display: none;

          ${CSS_MQ.atLeastMd} {
            display: block;

            ${desktopStickyStyles};
          }
        `,
      ]}
    >
      <div
        css={css`
          aspect-ratio: var(--aspect-ratio);
          position: relative;
        `}
      >
        <ContentfulImage
          assetId={props.primaryImage.sys.id}
          contentfulLink={{
            url: props.primaryImage.url,
            noTransparentBackground: false,
            requestedWidth: 600,
          }}
          lazyLoaded={"lazy"}
          sizes={"700px"}
          higherDPI={[0.5, 2]}
          attachPictureStyles={css`
            ${CSS_MQ.atLeastMd} {
              border: 1px solid ${CSS_COLORS.Grey0};
              border-radius: 2px;
            }

            display: block;
            height: 100%;
            width: 100%;
          `}
          css={css`
            width: 100%;
            height: 100%;
            object-fit: contain;

            background-color: ${CSS_COLORS.GreenWhite};

            padding: 20px;
            ${CSS_MQ.atLeastMd} {
              padding: 40px;
            }
          `}
        />

        <button
          onClick={() => props.openModal(props.primaryImage.url)}
          css={css`
            position: absolute;
            right: 0;
            bottom: 0;

            z-index: 1;

            width: 52px;
            height: 52px;

            display: flex;
            align-items: center;
            justify-content: center;

            cursor: pointer;

            transition: transform 0.15s ease-out;
            &:hover {
              transform: scale(1.05);
            }
          `}
        >
          <MagnifySvgIcon
            css={css`
              width: 24px;
              height: 24px;

              color: ${CSS_COLORS.Green};
            `}
          />
        </button>

        {props.children}
      </div>
    </div>
  );
};
